import client from '../../client'

export default {
  // 初期表示
  FirstDisplay: param => {
    return new Promise((resolve, reject) => {

      var url = '/api/CommonConfirmReserveInfo/CommonConfirmReserveInfoFirstDisplay'

      var qs = require('qs')
      var data = qs.stringify({
        ircd: param.ircd,
        tmzn: param.tmzn,
        jgcd: param.jgcd,
        hfkb: param.hfkb,
        nend: param.nend,
        sex: param.sex,
        kscd: param.kscd,
        courseJkcd: param.courseJkcd,
        opbrs: param.opbrs,
        opcds: param.opcds,
        optionJkcds: param.optionJkcds
      })

      var config = {
        method: 'post',
        url: url,
        data: data
      }

      client(config)
        .then(responce => {
          // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
          resolve({
            responce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })

    })
  },
  // ゲストログイン新規予約時
  // 4: ゲストログインかつ新規予約（個人）codeUserTypeGuestNewIndividual
  // 5: ゲストログインかつ新規予約（健保）codeUserTypeGuestNewHealth
  GuestNewReserve: param => {
    return new Promise((resolve, reject) => {

      var url = '/api/Account/CommonGuestNewReserve'

      var qs = require('qs')
      var data = qs.stringify({
        ircd: param.ircd,
        jgcd: param.jgcd,
        hksh: param.hksh,
        newHealthInsuranceSex: param.newHealthInsuranceSex,
        newHealthInsuranceNend: param.newHealthInsuranceNend,
        newHealthInsuranceAge: param.newHealthInsuranceAge,
        newHealthInsuranceHfkb: param.newHealthInsuranceHfkb,
        inputReserveSex: param.inputReserveSex,
        inputReserveBtdyYear: param.inputReserveBtdyYear,
        inputReserveBtdyMonth: param.inputReserveBtdyMonth,
        inputReserveBtdyDate: param.inputReserveBtdyDate,
        inputReserveAge: param.inputReserveAge,
        inputReserveHfkb: param.inputReserveHfkb,
        kscd: param.kscd,
        courseJkcd: param.courseJkcd,
        opbr: param.opbr,
        opcd: param.opcd,
        optionJkcd: param.optionJkcd,
        reserveDate: param.reserveDate,
        reserveTmzn: param.reserveTmzn,
        jgnm: param.jgnm,
        hkkg: param.hkkg,
        hkno: param.hkno,
        cmnm: param.cmnm,
        nam1: param.nam1,
        nam2: param.nam2,
        ryk1: param.ryk1,
        ryk2: param.ryk2,
        zip1: param.zip1,
        zip2: param.zip2,
        adr1: param.adr1,
        adr2: param.adr2,
        adr3: param.adr3,
        tel1: param.tel1,
        syno: param.syno,
        email: param.email,
        dmkb: param.dmkb,
        mem1: param.mem1
      })

      var config = {
        method: 'post',
        url: url,
        data: data
      }

      client(config)
        .then(responce => {
          // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
          resolve({
            reserveResponce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })
    })
  },
  // ログイン済み新規予約
  // 0: マイページ経由かつ新規予約（個人）codeUserTypeMyPageNewIndividual
  // 1: マイページ経由かつ新規予約（健保）codeUserTypeMyPageNewHealth
  // 6: 途中ログインかつ新規予約（個人）codeUserTypeEnRouteNewIndividual
  // 7: 途中ログインかつ新規予約（健保）codeUserTypeEnRouteNewHealth
  LoginedNewReserve: param => {
    return new Promise((resolve, reject) => {

      var url = '/api/Account/CommonLoginedNewReserve'

      var qs = require('qs')
      var data = qs.stringify({
        userId: param.userId,
        ircd: param.ircd,
        jgcd: param.jgcd,
        hksh: param.hksh,
        newHealthInsuranceSex: param.newHealthInsuranceSex,
        newHealthInsuranceNend: param.newHealthInsuranceNend,
        newHealthInsuranceAge: param.newHealthInsuranceAge,
        newHealthInsuranceHfkb: param.newHealthInsuranceHfkb,
        inputReserveSex: param.inputReserveSex,
        inputReserveBtdyYear: param.inputReserveBtdyYear,
        inputReserveBtdyMonth: param.inputReserveBtdyMonth,
        inputReserveBtdyDate: param.inputReserveBtdyDate,
        inputReserveAge: param.inputReserveAge,
        inputReserveHfkb: param.inputReserveHfkb,
        kscd: param.kscd,
        courseJkcd: param.courseJkcd,
        opbr: param.opbr,
        opcd: param.opcd,
        optionJkcd: param.optionJkcd,
        reserveDate: param.reserveDate,
        reserveTmzn: param.reserveTmzn,
        jgnm: param.jgnm,
        hkkg: param.hkkg,
        hkno: param.hkno,
        cmnm: param.cmnm,
        nam1: param.nam1,
        nam2: param.nam2,
        ryk1: param.ryk1,
        ryk2: param.ryk2,
        zip1: param.zip1,
        zip2: param.zip2,
        adr1: param.adr1,
        adr2: param.adr2,
        adr3: param.adr3,
        tel1: param.tel1,
        syno: param.syno,
        email: param.email,
        dmkb: param.dmkb,
        mem1: param.mem1
      })

      var config = {
        method: 'post',
        url: url,
        headers: {
          'Authorization': 'Bearer ' + param.token,
        },
        data: data
      }

      client(config)
        .then(responce => {
          // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
          resolve({
            reserveResponce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })
    })
  },
  // ログイン済み予約変更
  // 2: マイページ経由かつ予約変更（個人）codeUserTypeMyPageChangeIndividual
  // 3: マイページ経由かつ予約変更（健保）codeUserTypeMyPageChangeHealth
  LoginedChangeReserve: param => {
    return new Promise((resolve, reject) => {

      var url = '/api/Account/CommonLoginedChangeReserve'

      var qs = require('qs')
      var data = qs.stringify({
        choiceUkno: param.choiceUkno,
        userId: param.userId,
        ircd: param.ircd,
        jgcd: param.jgcd,
        hksh: param.hksh,
        newHealthInsuranceSex: param.newHealthInsuranceSex,
        newHealthInsuranceNend: param.newHealthInsuranceNend,
        newHealthInsuranceAge: param.newHealthInsuranceAge,
        newHealthInsuranceHfkb: param.newHealthInsuranceHfkb,
        inputReserveSex: param.inputReserveSex,
        inputReserveBtdyYear: param.inputReserveBtdyYear,
        inputReserveBtdyMonth: param.inputReserveBtdyMonth,
        inputReserveBtdyDate: param.inputReserveBtdyDate,
        inputReserveAge: param.inputReserveAge,
        inputReserveHfkb: param.inputReserveHfkb,
        kscd: param.kscd,
        courseJkcd: param.courseJkcd,
        opbr: param.opbr,
        opcd: param.opcd,
        optionJkcd: param.optionJkcd,
        reserveDate: param.reserveDate,
        reserveTmzn: param.reserveTmzn,
        jgnm: param.jgnm,
        hkkg: param.hkkg,
        hkno: param.hkno,
        cmnm: param.cmnm,
        nam1: param.nam1,
        nam2: param.nam2,
        ryk1: param.ryk1,
        ryk2: param.ryk2,
        zip1: param.zip1,
        zip2: param.zip2,
        adr1: param.adr1,
        adr2: param.adr2,
        adr3: param.adr3,
        tel1: param.tel1,
        syno: param.syno,
        email: param.email,
        dmkb: param.dmkb,
        mem1: param.mem1
      })

      var config = {
        method: 'post',
        url: url,
        headers: {
          'Authorization': 'Bearer ' + param.token,
        },
        data: data
      }

      client(config)
        .then(responce => {
          // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
          resolve({
            reserveResponce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })
    })
  },
  // 新規予約確定、ログイン処理後、ユーザー情報取得
  GetUserInfo: param => {
    return new Promise((resolve, reject) => {

      var url = '/api/CommonConfirmReserveInfo/CommonConfirmReserveInfoGetUserInfo'

      var qs = require('qs')
      var data = qs.stringify({
        userId: param.userId
      })

      var config = {
        method: 'post',
        url: url,
        headers: {
          'Authorization': 'Bearer ' + param.token,
        },
        data: data
      }

      client(config)
        .then(responce => {
          // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
          resolve({
            userInfoResponce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/Common/ConfirmReserveInfo/CommonConfirmReserveInfoApi.js